import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, TelegramIcon, TelegramShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from "react-share";
import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { ContainerModal } from "./ContainerModal";
import { CustomInput } from "../../../../core/components/CustomInput";
import { CustomButton } from "../../../../core/components/CustomButton";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../core/store/store";

export const InviteYourFriends = ({ isOpenInvite, setIsOpenInvite }: { isOpenInvite: boolean; setIsOpenInvite: React.Dispatch<React.SetStateAction<boolean>> }) => {
	const { referralCode } = useSelector((state: RootState) => state.onboarding);
	const shareUrl = `https://app.unjabbed.app/auth/login?referCode=${referralCode?.code}`;
	const [isCopied, setIsCopied] = useState<boolean>(false);
	const [inputValue, setInputValue] = useState<string>(shareUrl);
	const [isFocused] = useState<boolean>(false);
	const handleCopyClick = () => {
		navigator.clipboard
			.writeText(inputValue)
			.then(() => {
				setIsCopied(true);
				setTimeout(() => setIsCopied(false), 2000);
			})
			.catch((err) => {
				alert("Error al copiar el texto: " + err);
			});
	};
	const truncateText = (text: string, maxLength: number) => {
		return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
	};
	const displayValue = isFocused ? inputValue : truncateText(inputValue, 32);
	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setInputValue(e.target.value);
	};

	return (
		<>
			<ContainerModal
				title="Invite your friend"
				isOpen={isOpenInvite}
				onRequestClose={() => setIsOpenInvite(false)}
			>
				<Column className="pb-10 sm:pb-20">
					<Row mainAxisAlignment="center" className="max-sm:flex-wrap gap-5">
						<FacebookShareButton
							url={shareUrl}
							className="flex flex-col items-center gap-0.5"
						>
							<FacebookIcon
								size={52}
								round={true}
							/>
							Facebook
						</FacebookShareButton>
						<WhatsappShareButton
							url={shareUrl}
							className="flex flex-col items-center gap-0.5"
						>
							<WhatsappIcon
								size={52}
								round={true}
							/>
							WhatsApp
						</WhatsappShareButton>

						<TwitterShareButton
							url={shareUrl}
							className="flex flex-col items-center gap-0.5"
						>
							<TwitterIcon
								size={52}
								round={true}
							/>
							Twitter
						</TwitterShareButton>

						<TelegramShareButton
							url={shareUrl}
							className="flex flex-col items-center gap-0.5"
						>
							<TelegramIcon
								size={52}
								round={true}
							/>
							Telegram
						</TelegramShareButton>

						<EmailShareButton
							url={shareUrl}
							className="flex flex-col items-center gap-0.5"
						>
							<EmailIcon
								size={52}
								round={true}
							/>
							Email
						</EmailShareButton>
					</Row>
					<CustomInput
						className="mt-5 w-full max-w-sm"
						value={displayValue}
						onChange={handleInputChange}
						placeholder="Enter additional info"
						readOnly
						endAdornment={
							<CustomButton
								small
								color="primary"
								onClick={handleCopyClick}
								className="ml-2 text-white py-2 px-4 rounded"
							>
								{isCopied ? "Copied!" : "Copy"}
							</CustomButton>
						}
					/>
				</Column>
			</ContainerModal>
		</>
	);
};
